;"use strict";
window.overwatch = window.overwatch || {};
window.overwatch.SkuModel = {

	Mediator: null,

	eventNameChange: null,

	countrySkuMap: null,

	currentList: null,

	current: null,

	currentIndex: null,

	$doc: $(document),

	/**
	 * [init description]
	 * 
	 * @param [config] {Object} Config object
	 * @param [config.eventNameChange] 
	 * @param [config.countrySkuMap] 
	 * @param [config.currentList] 
	 * @param [config.defaultId] 
	 */
	init: function(config) {
		var self = this;

		this.Mediator = config.Mediator;
		this.eventNameChange = config.eventNameChange;
		this.countrySkuMap = config.countrySkuMap;
		this.currentList = config.currentList;

		// initializes 'current' and 'currentList' and fires initial change event
		this.setCurrentById(config.defaultId);
	},

	getCurrent: function() {
		return this.current;
	},

	getPrevious: function() {
		var prev = this._mod(this.currentIndex - 1, this.currentList.length);
		return this.currentList[prev];
	},

	getNext: function() {
		var next = this._mod(this.currentIndex + 1, this.currentList.length);
		return this.currentList[next];
	},

	getCurrentById: function(id) {
		for (var i = this.currentList.length - 1; i >= 0; i--) {
			var sku = this.currentList[i];
			if (sku.id === id) {
				return sku;
			}
		};
		console.error(id + " SKU not found.");
	},

	setCurrent: function(sku) {
		this.current = sku;
		this.currentIndex = this.currentList.indexOf(sku);
		this._publish();
	},

	setCurrentById: function(id) {
		var sku = this.getCurrentById(id);
		this.setCurrent(sku);
	},

	updateList: function(countryCode) {
		this.currentList = this.countrySkuMap[countryCode];
		this.setCurrentById(this.current.id);
	},

	_publish: function() {
		this.Mediator.publish(this.eventNameChange, this.current);
	},

	_mod: function(x, y) {
		return (((x % y) + y) % y);
	}

};
